<div *transloco="let t" class="feed-root">
  <div class="feed-title-container">
    <app-header [hasDashedLine]="false">{{ labels.activitiesFeed }}</app-header>
  </div>
  <div class="dashed-line"></div>
  <div class="filter-container">
    <div class="left-filters">
      <app-filter-container
        class="left-selectors"
        (selectFilterClick)="updateFilter($event)"
        [baseSimpleChipData]="chipContents"
        [statusChips]="this.statusChips"
        [seriesChips]="this.seriesChips"
        [filters]="this.filters"
      ></app-filter-container>
    </div>
    <div class="right-filters">
      <app-country-selector
        *ngIf="countries?.length"
          class="country-selector"
          [countries]="countries"
          (valueChange)="onCountryFilterChanged($event)">
      </app-country-selector>
      <div class="search">
        <app-input
          id="search-business-input"
          [placeholder]="t('search')"
          [type]="'search'"
          [control]="search"
          (searchClick)="updateFilter(filters)"
        >
        </app-input>
      </div>
    </div>


  </div>
  <div class="feed-list loading" *ngIf="pullingFeed && !feedItems?.length">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
  <div
    class="feed-list"
    *ngIf="feedItems?.length"
    infinite-scroll
    [infiniteScrollDistance]="0.1"
    [scrollWindow]="false"
    [immediateCheck]="true"
    (scrolled)="pullFeed()"
  >
    <div *ngFor="let item of feedItems">
      <div class="year-area">
        {{ getMonthString(item.month) }} {{ item.year }}
      </div>
      <div class="cards-group">
        <div class="card" *ngFor="let card of item.items">
          <app-coupon-card
            [headerTitle]="card.businessName"
            [picture]="card.picture"
            [expirationDate]="card.expireDate"
            [couponStatus]="card.couponStatus"
            [printerModel]="card.productName"
            [description]="card.businessName"
            [discountValue]="card.discountValue"
            [serial]="card.serialNumber"
            [couponCode]="card.couponCode"
            [reclaimedDate]="card.createdDate!"
            [cost]="card.rewardCost"
            [businessId]="card.businessId"
            [rewardDiscount]="card.rewardDiscount"
            [rewardName]="card.rewardName"
            [rewardType]="card.rewardType"
            [usedDate]="card.usedDate"
            [note]="card.note"
            [id]="card.couponId"
            [invoice]="card.invoice"
            [resellerIdentification]="card.resellerIdentification"
          >
          </app-coupon-card>
        </div>
      </div>
    </div>
    <div class="loading-more-items">
      <mat-spinner *ngIf="pullingFeed && feedItems?.length"></mat-spinner>
    </div>
  </div>
  <div *ngIf="!feedItems?.length && !pullingFeed" class="no-feed-list">
    <app-empty-feed
      icon="list_alt"
      header="{{ labels.notFound }}"
      text="{{ labels.notFoundDescription }}"
    >
    </app-empty-feed>
  </div>
</div>
